export default __webpack_public_path__ + "static/media/avatar4.1fd0cd57.png";